// extracted by mini-css-extract-plugin
export default {"container":"SectionLink_container__nKdJS","label":"SectionLink_label__fVMZn","arrow":"SectionLink_arrow__qSubu","blue":"SectionLink_blue__NovYh","green":"SectionLink_green__4VXCF"};